module.exports = __webpack_public_path__ + "static/media/Intiri.1e6737cd.jpeg";